// Translation bundles for preview mode. Pages fetch their header text from
// .../translations/api/admin/pages/<page>; here each page gets its English title and taglines,
// so headers aren't blank. Keys follow utils/getLanguage (getBundleTranslation / getPageTranslation).

const PAGES = {
	listing_management: {
		page_title: 'Listing Management',
		tagline: 'Manage your locations and keep listing details accurate across every source.',
		'tagline.listings': 'Review every listing connected to your locations.',
		'tagline.google': 'Manage your Google Business Profile listings.',
		'tagline.apple': 'Manage your Apple Business Connect listings.',
		'tagline.facebook': 'Manage your Facebook pages.',
		'tagline.history': 'Track changes made to your listings.',
	},
	reality_check: { page_title: 'RealityCheck™', tagline: 'Compare your first-party data with what Google shows and resolve differences.' },
	listing_performance: {
		page_title: 'Listing Performance',
		'tagline.overview': 'See how customers find and act on your listings.',
		'tagline.locations': 'Compare performance location by location.',
		'tagline.leadership_grid': 'Rank locations by views and actions.',
	},
	media_management: {
		page_title: 'Media Management',
		'tagline.brand': 'Upload, tag and track the photos you publish.',
		'tagline.public': 'Review photos customers add to your listings.',
		'tagline.by_location': 'See photos for each location.',
		'tagline.add_new': 'Add new photos and videos to your listings.',
	},
	audit_logs: {
		page_title: 'Audit Logs',
		'tagline.overview': 'Track every change made to your listings.',
		'tagline.updates': 'Review listing updates field by field.',
	},
	edit_history: { page_title: 'Edit History', tagline: 'Track and view a record of all edits pushed within the platform.' },
	source_mapping: { page_title: 'Source Mapping', tagline: 'Connect each location to its listings on every source.' },
	reviews_inbox: { page_title: 'ReviewsInbox™' },
	reviews_dashboard: {
		page_title: 'Reviews Dashboard',
		'tagline.overview': 'Track review volume, ratings and response performance.',
		'tagline.reviews': 'Explore review trends over time.',
		'tagline.responses': 'See how quickly and how often reviews are answered.',
		'tagline.energy': 'Spot shifts in customer sentiment.',
	},
	location_ratings: {
		page_title: 'Location Ratings',
		'tagline.locations': 'Compare ratings and review activity location by location.',
		'tagline.grid_view': 'Compare locations against nearby competitors.',
		'tagline.velocity': 'See how fast each location gains reviews.',
		'tagline.influence': 'See which locations move your overall rating.',
	},
	sentiment_analysis: { page_title: 'Sentiment Analysis', tagline: 'Understand what customers love and what needs attention.' },
	auto_response: { page_title: 'Intelligent Auto Response', tagline: 'Create AI response campaigns with brand-approved timing, tone, and control.' },
	competitor_reviews: { page_title: 'Competitor Reviews', tagline: 'Benchmark performance by tracking competitor listings, reviews, and trends.' },
	review_controls: { page_title: 'Review Control', tagline: 'Set how reviews are replied to, approved and shown.' },
	posts_showcases: { page_title: 'Posts & Showcases', tagline: 'Create, schedule and publish posts to your listings.' },
	review_showcase: { page_title: 'Review Showcase', tagline: 'Show your best reviews on your website.' },
	reports_notices: { page_title: 'Reports & Notices', tagline: 'Manage how reports are created, scheduled, and delivered to recipients.' },
	data_studio: { page_title: 'Data Studio', tagline: 'Export your platform Keyword, Review, and Photo data on demand.' },
	ai_agents: { page_title: 'AI Agents', tagline: 'Reduce manual workload by delegating workflows to AI agents.' },
	automation_center: { page_title: 'Automation Center', tagline: 'Scale repetitive workflows with custom rules that trigger real-time actions.' },
	calendar: { page_title: 'Calendar', tagline: 'See every scheduled post and listing update in one place.' },
	profile_settings: { page_title: 'Profile Settings', tagline: 'Customize your profile name, icon, logos, and date format preferences.' },
	integrations: { page_title: 'Integrations', tagline: 'Connect sources that power your listings, reviews, and local visibility.' },
	manage_users: { page_title: 'Manage Users', tagline: 'Easily invite, edit or remove team members to control access.' },
	manage_roles: { page_title: 'Manage Roles', tagline: 'Build custom roles to define what team members can see and do.' },
	manage_teams: { page_title: 'Manage Teams', tagline: 'Create teams to route reviews, tasks, and workflows.' },
	navigation_control: { page_title: 'Navigation Control', tagline: 'Build your own right-hand navigation panel for a streamlined workflows.' },
	filter_composer: { page_title: 'Filter Composer', tagline: 'Build multi-dimension filters customized to your unique data structures.' },
	saved_tags_filters: { page_title: 'Saved Tags & Filters', tagline: 'Save filters and keyword groups to reuse across the platform.' },
};

const LANGUAGES = [{ code: 'en-US', name: 'English', is_active: true }];

const bundle = (strings) => ({
	rows: Object.keys(strings).map((key_name) => ({ key_name, translations: { 'en-US': strings[key_name] } })),
});

// Response body for a translation URL, or null if the URL isn't a translation request.
export const translationFor = (url) => {
	if (url.indexOf('/translations/') === -1) return null;
	if (/\/languages(\?|$)/.test(url)) return LANGUAGES;
	const m = url.match(/\/pages\/([^/?]+)/);
	// Pages without an entry (e.g. left_navigation) fall back to their built-in English text.
	return bundle((m && PAGES[m[1]]) || {});
};
